import { configurationService } from '../../helpers/services/configuration.service';
import i18n from '@/i18n'
import { sharedHelper } from '@/utils'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    status: {},
    details: {},
}
export const CONFIGURATION_MODULE = 'configuration';

// define action
export const GET_ALL_CONFIGURATIONS = 'getAllConfigurations';
export const UPDATE_CONFIGURATION = 'updateConfiguration';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const ALL_CONFIGURATION_SUCCESS = "allConfigurationSuccess";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_CONFIGURATIONS]({ commit }) {
        configurationService
            .getAllConfigurations()
            .then(
                (result) => {
                    commit(ALL_CONFIGURATION_SUCCESS, { data: result })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE);
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_CONFIGURATION]({ dispatch, commit }, { data }) {
        commit(REQUEST)
        configurationService
            .updateConfiguration(data.key, data.value)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    let message = i18n.t("message.updateXSuccess", [i18n.t('module.configuration')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS);
                    dispatch(GET_ALL_CONFIGURATIONS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE);
                }
            )
    },
};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true };
    },
    [ALL_CONFIGURATION_SUCCESS](state, { data }) {
        let d = data.data

        if (data.pagination) {
            state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)
        }

        state.list.data = d.map((o) => {
            return {
                key: o.key,
                value: o.value,
                valueType: o.value_type,
                isViewable: o.is_viewable,
                updatedAt: o.updated_at,
            }
        })
    },
}
